import { createFileRoute } from '@tanstack/react-router';
import { LoginScreen } from '../features/auth/LoginScreen';

export interface LoginSearch {
  /** true — сюди привів 401, а не власне бажання вийти. */
  expired: boolean;
}

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    expired: search['expired'] === true || search['expired'] === 'true',
  }),
  component: LoginRoute,
});

function LoginRoute(): React.JSX.Element {
  const { expired } = Route.useSearch();
  return <LoginScreen expired={expired} />;
}
